import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["getTabs", "value", "orientation", "onItemClick", "viewVariant", "size", "fullWidth"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useCallback, useMemo } from 'react';
import { Box } from '@mui/material';
import { Tab } from '@elements/tab';
import { StyledTabs } from './tabs.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/**
 * Tabs element.
 *
 * @author Ihar Kazlouski
 * @function Tabs
 * @category elements
 * @return {FC} router tabs element.
 */
var Tabs = function Tabs(_ref) {
  var getTabs = _ref.getTabs,
      value = _ref.value,
      orientation = _ref.orientation,
      onItemClick = _ref.onItemClick,
      _ref$viewVariant = _ref.viewVariant,
      viewVariant = _ref$viewVariant === void 0 ? 'underline' : _ref$viewVariant,
      size = _ref.size,
      fullWidth = _ref.fullWidth,
      restProps = _objectWithoutProperties(_ref, _excluded);

  /**
   * Item click handler.
   *
   * @author Mikhail Siutsou
   * @param {TabTypes} tab tab.
   * @return {() => void} click handler.
   */
  var itemClickHandler = useCallback(function (tab) {
    return function () {
      if (onItemClick) {
        onItemClick(tab);
      }
    };
  }, [onItemClick]);
  var tabIsExist = useMemo(function () {
    return !!getTabs().find(function (tab) {
      return tab.value === value;
    });
  }, [getTabs, value]);
  return /*#__PURE__*/_jsx(Box, {
    children: /*#__PURE__*/_jsxs(StyledTabs, _objectSpread(_objectSpread({}, restProps), {}, {
      value: tabIsExist ? value : 'hidden',
      orientation: orientation,
      viewVariant: viewVariant,
      size: size,
      children: [getTabs().map(function (tab) {
        return /*#__PURE__*/_jsx(Tab, {
          value: tab.value,
          label: tab.label,
          onClick: itemClickHandler(tab),
          icon: tab === null || tab === void 0 ? void 0 : tab.icon,
          iconPosition: tab === null || tab === void 0 ? void 0 : tab.iconPosition,
          viewVariant: viewVariant,
          size: size
        }, tab.key);
      }), /*#__PURE__*/_jsx(Tab, {
        value: "hidden",
        label: "",
        hidden: true,
        disableFocusRipple: true,
        component: "span"
      })]
    }))
  });
};

export { Tabs };